import React, { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'

const PolicyItem = ({ met, messageId, values }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      {met ? (
        <CheckCircleOutlineIcon sx={{ fontSize: 16, color: 'success.main' }} />
      ) : (
        <RadioButtonUncheckedIcon sx={{ fontSize: 16, color: 'text.disabled' }} />
      )}
      <Typography
        variant="caption"
        color={met ? 'success.main' : 'text.secondary'}
      >
        <FormattedMessage id={messageId} values={values} />
      </Typography>
    </Box>
  )
}

const PasswordPolicyChecklist = ({ value, policy }) => {
  const checks = useMemo(() => {
    if (!policy) return []

    const result = []
    const password = value || ''

    if (policy.minLength) {
      result.push({
        key: 'minLength',
        met: password.length >= policy.minLength,
        messageId: 'passwordPolicy.minLength',
        values: { count: policy.minLength }
      })
    }

    if (policy.requireLowercase) {
      result.push({
        key: 'lowercase',
        met: /[a-z]/.test(password),
        messageId: 'passwordPolicy.requireLowercase'
      })
    }

    if (policy.requireUppercase) {
      result.push({
        key: 'uppercase',
        met: /[A-Z]/.test(password),
        messageId: 'passwordPolicy.requireUppercase'
      })
    }

    if (policy.requireNumber) {
      result.push({
        key: 'number',
        met: /[0-9]/.test(password),
        messageId: 'passwordPolicy.requireNumber'
      })
    }

    if (policy.excludeSpecial) {
      result.push({
        key: 'noSpecial',
        met: /^[a-zA-Z0-9]*$/.test(password),
        messageId: 'passwordPolicy.excludeSpecial'
      })
    }

    return result
  }, [value, policy])

  if (checks.length === 0) {
    return null
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25, mt: 0.5 }}>
      {checks.map((check) => (
        <PolicyItem
          key={check.key}
          met={check.met}
          messageId={check.messageId}
          values={check.values}
        />
      ))}
    </Box>
  )
}

export default PasswordPolicyChecklist
